import { render, staticRenderFns } from "./ActionDecideIfNewHomeIdIsRequired.vue?vue&type=template&id=09cbfaad&scoped=true&"
import script from "./ActionDecideIfNewHomeIdIsRequired.vue?vue&type=script&lang=js&"
export * from "./ActionDecideIfNewHomeIdIsRequired.vue?vue&type=script&lang=js&"
import style0 from "./ActionDecideIfNewHomeIdIsRequired.vue?vue&type=style&index=0&id=09cbfaad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cbfaad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VDataTable,VTextarea})
